import {
  Button,
  Heading,
  Sizes,
  Text,
} from '@sede-enterprise/shell-ds-react-framework';
import {
  NoSitesCard,
  NoSitesContainer,
} from 'components/ErrorStates/ErrorStateContentBox/ErrorStateContentBox.styled';
import { NoDataLighthouse } from 'components/ErrorStates/ErrorStateSvg/NoDataLighthouse';
import { ReactNode } from 'react';
import { useNavigate } from 'react-router';

const DefaultActions = () => {
  const navigate = useNavigate();
  return <Button onClick={() => navigate('/')}>Select a company</Button>;
};

export const ErrorStateContentBox = ({
  headingText,
  subText,
  actions = <DefaultActions />,
}: {
  headingText: string;
  subText: string | ReactNode;
  actions?: ReactNode;
}) => {
  return (
    <NoSitesContainer>
      <NoSitesCard>
        <NoDataLighthouse />
        <Heading level={4} bold>
          {headingText}
        </Heading>
        <Text type={'p'} size={Sizes.Small} style={{ textAlign: 'center' }}>
          {subText}
        </Text>
        {actions}
      </NoSitesCard>
    </NoSitesContainer>
  );
};
